import { useState } from "react";
import MarketingBot from "../MarketingBot";

export default function FloatingMarketingBot() {

  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Chat Window */}

      {open && (
        <div
          className="
            fixed
            bottom-24
            right-5
            z-[9999]
            w-[380px]
            h-[650px]
            bg-white
            rounded-3xl
            shadow-2xl
            overflow-hidden
            border
            border-gray-200
          "
        >
          <div
            className="
              bg-gradient-to-r
              from-pink-500
              to-purple-600
              text-white
              px-5
              py-4
              flex
              justify-between
              items-center
            "
          >
            <div>
              <h3 className="font-bold">
                MerinaSoft AI
              </h3>

              <p className="text-xs opacity-90">
                Online now
              </p>
            </div>

            <button
              onClick={() =>
                setOpen(false)
              }
              className="
                text-white
                text-xl
                hover:opacity-70
              "
            >
              ✕
            </button>
          </div>

          <div
            className="
              h-[calc(100%-72px)]
            "
          >
            <MarketingBot />
          </div>
        </div>
      )}

      {/* Floating Bubble */}

      <button
        onClick={() =>
          setOpen(!open)
        }
        className="
          fixed
          bottom-5
          right-5
          z-[9999]
          w-16
          h-16
          rounded-full
          bg-gradient-to-r
          from-pink-500
          to-purple-600
          shadow-2xl
          text-white
          text-2xl
          hover:scale-110
          transition
        "
      >
        💬
      </button>
    </>
  );
}